import {useQuery, useQueryClient} from '@tanstack/react-query'
import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {QUERIES} from '../../../_metronic/helpers'
import {v2_get_request_api} from '../../../api/get'
import {Gallery} from '../../modules/apps/gallery/gallerys-list/core/_models'
import {queryKey} from './Gallery'
import {fileSrc} from '../../../_component/fileUtils'

export const GalleryDetailsPage: FC = () => {
  const queryClient = useQueryClient()
  const {id} = useParams()
  const {data: gallery}: Partial<{data: Gallery}> = useQuery(
    [QUERIES.GALLERY_LIST + '/' + id, 'includes=GalleryImage'],
    v2_get_request_api,
    {
      enabled: !!id,
      placeholderData: (
        queryClient.getQueryData([QUERIES.GALLERY_LIST, queryKey]) as any
      )?.entities?.find((d: any) => d.id === id),
    }
  )
  return (
    <div id='kt_app_content' className='app-content flex-column-fluid'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        {/*begin::About card*/}
        <div className='card'>
          {/*begin::Body*/}
          <div className='card-body p-lg-17'>
            {/*begin::About*/}
            <div className='mb-18'>
              {/*begin::Wrapper*/}
              <div className='mb-10'>
                {/*begin::Top*/}
                <div className='text-center mb-15'>
                  {/*begin::Title*/}
                  <h3 className='fs-2hx text-dark mb-5'>{gallery?.title}</h3>
                  {/*end::Title*/}
                </div>
                {/*begin::Description*/}
                <div className='fs-5 fw-semibold text-gray-600'>
                  {/*begin::Text*/}
                  <p className='mb-8' dangerouslySetInnerHTML={{__html: gallery?.note || ''}}></p>
                  {/*end::Text*/}
                </div>
                {/*end::Description*/}
                {/*end::Top*/}
                {/*begin::Overlay*/}
                {/*begin::Image*/}
                <div className='row g-10'>
                  {gallery?.gallery_images?.map((entity) => (
                    <div className='col-md-4' key={entity.id}>
                      {/*begin::Publications post*/}
                      <div className='card-xl-stretch me-md-6'>
                        {/*begin::Overlay*/}
                        <a
                          className='d-block overlay mb-4'
                          data-fslightbox='lightbox-hot-sales'
                          href={entity.image ? fileSrc(entity.image) : ''}
                          target='_blank'
                          rel='noreferrer'
                        >
                          {/*begin::Image*/}
                          <div
                            className='overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded min-h-175px'
                            style={{
                              backgroundImage: `url(${entity.image ? fileSrc(entity.image) : ''})`,
                            }}
                          ></div>
                          {/*end::Image*/}
                          {/*begin::Action*/}
                          <div className='overlay-layer bg-dark card-rounded bg-opacity-25'>
                            <i className='bi bi-eye-fill fs-2x text-white'></i>
                          </div>
                          {/*end::Action*/}
                        </a>
                        {/*end::Overlay*/}
                      </div>
                      {/*end::Publications post*/}
                    </div>
                  ))}
                </div>
                {/*end::Image*/}
              </div>
              {/*end::Wrapper*/}
            </div>
            {/*end::About*/}
          </div>
          {/*end::Body*/}
        </div>
        {/*end::About card*/}
      </div>
      {/*end::Content container*/}
    </div>
  )
}
